module.exports = __webpack_public_path__ + "img/physics.cca68c86.png";